/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc)
 */
 
import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { RecipeInputConsumableBase } from 'shared/dbo/RecipeInputConsumable';

export interface RecipeInputConsumableIndexedDb {
	id: string;
	recipeId: string;
	consumableId: string;
	quantity: number;
	unitId?: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isRecipeInputConsumableIndexedDb = (obj: unknown): obj is RecipeInputConsumableIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ recipeId: unknown }>(obj, 'recipeId') || !(typeof obj.recipeId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ consumableId: unknown }>(obj, 'consumableId') || !(typeof obj.consumableId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ quantity: unknown }>(obj, 'quantity') || !(typeof obj.quantity === 'number')) {
		return false;
	}
	if (hasPropOfType<{ unitId: unknown }>(obj, 'unitId') && !(typeof obj.unitId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: RecipeInputConsumableBase): RecipeInputConsumableIndexedDb => ({
	id: obj.id.toString(),
	recipeId: obj.recipeId.toString(),
	consumableId: obj.consumableId.toString(),
	quantity: obj.quantity,
	unitId: typeof obj.unitId === 'undefined' ? obj.unitId : obj.unitId.toString(),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: RecipeInputConsumableIndexedDb): RecipeInputConsumableBase => ({
	id: UUID.fromString(obj.id),
	recipeId: UUID.fromString(obj.recipeId),
	consumableId: UUID.fromString(obj.consumableId),
	quantity: obj.quantity,
	unitId: typeof obj.unitId === 'undefined' ? obj.unitId : UUID.fromString(obj.unitId),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdRecipeInputConsumable: LocalDatabaseTableDefinition<RecipeInputConsumableBase, RecipeInputConsumableIndexedDb> = {
	tableName: 'recipeInputConsumables',
	indexColumns: ['recipeId', 'consumableId'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
